import React from 'react'

export default function FloatingCTA() {
  return (
    <aside
      aria-label="Hurtig kontakt"
      className="fixed bottom-5 right-4 sm:bottom-6 sm:right-6 z-40 flex flex-col items-end gap-2.5 sm:gap-3 pointer-events-none"
    >
      {/* Email Floating Button */}
      <div className="relative group flex items-center pointer-events-auto">
        {/* Desktop hover label pill */}
        <span
          className="hidden sm:inline-flex items-center px-2.5 py-1 mr-2 rounded-lg bg-[#0d3835] text-white text-xs font-medium shadow-md opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-200 pointer-events-none whitespace-nowrap"
          role="tooltip"
        >
          Send e-mail
        </span>

        <a
          href="mailto:havdruprengoring@gmail.com"
          aria-label="Send e-mail til havdruprengoring@gmail.com"
          className="flex h-11 w-11 sm:h-12 sm:w-12 items-center justify-center rounded-full bg-white text-slate-700 border border-slate-200 shadow-md shadow-slate-900/10 hover:bg-orange-50 hover:text-[#f05a28] hover:border-orange-300 hover:scale-108 active:scale-95 transition-all duration-200 cursor-pointer"
        >
          <i className="fa-solid fa-envelope text-base sm:text-lg" aria-hidden="true" />
          <span className="sr-only">Send e-mail til Havdrup Rengøring</span>
        </a>
      </div>

      {/* Phone Floating Button */}
      <div className="relative group flex items-center pointer-events-auto">
        {/* Desktop hover label pill */}
        <span
          className="hidden sm:inline-flex items-center px-2.5 py-1 mr-2 rounded-lg bg-[#0d3835] text-white text-xs font-medium shadow-md opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-200 pointer-events-none whitespace-nowrap"
          role="tooltip"
        >
          Ring 31 34 16 32
        </span>

        <a
          href="tel:31341632"
          aria-label="Ring til Havdrup Rengøring på 31 34 16 32"
          className="relative flex h-12 w-12 sm:h-13 sm:w-13 items-center justify-center rounded-full bg-[#f05a28] text-white shadow-lg shadow-orange-950/25 hover:bg-[#db4d1d] hover:scale-108 active:scale-95 transition-all duration-200 cursor-pointer"
        >
          <i className="fa-solid fa-phone text-base sm:text-lg" aria-hidden="true" />
          <span className="sr-only">Ring på 31 34 16 32</span>
        </a>
      </div>
    </aside>
  )
}
